












import { computed, defineComponent, getCurrentInstance } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import { getAbsUrl, getLiveUrl, shareUrl } from "@/lib/urlHelpers";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import Share from "@/components/Share";

export default defineComponent({
  name: "GoingLiveConfirm",
  components: { BaseConfirm, BaseButton, Share },
  props: {
    show: { type: Boolean, required: true },
  },
  setup(_, { root, emit }) {
    const vm = getCurrentInstance();
    const { authUserStrict } = useAuthUser();
    const liveUrl = getLiveUrl(authUserStrict.value);
    const shareLink = computed(() => {
      const urlPart = vm?.$router.resolve(liveUrl).href;
      return urlPart ? getAbsUrl(urlPart) : "";
    });
    const copyLiveLink = () => shareUrl(shareLink.value, $t("Link copied"));
    const goLive = () => {
      emit("close");
      root.$router.push(liveUrl);
    };

    return {
      shareLink,
      copyLiveLink,
      goLive,
    };
  },
});
